 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];

 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		// chunk prefetching for javascript
 		prefetchChunks.forEach(function(chunkId) {
 			if(installedChunks[chunkId] === undefined) {
 				installedChunks[chunkId] = null;
 				var link = document.createElement('link');

 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "prefetch";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				document.head.appendChild(link);
 			}
 		});
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		71: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		71: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"2":"cycling-workouts~dashboard~planner~workout-builder~zwift-importer","3":"cycling-workouts~planner~workout-builder~zwift-importer","4":"vendors~activity~cycling-workouts~workout-builder~zwift-importer","5":"cycling-workouts~workout-builder~zwift-importer","6":"vendors~dashboard~planner~settings","7":"vendors~glossary~settings~tooltip-modal","10":"glossary~tooltip-modal","66":"activity","67":"admin","68":"ai-cycling-coach","69":"alternatives","70":"ambassadors","72":"changelog","73":"cycling-workouts","74":"dashboard","75":"glossary","76":"help","77":"highcharts","78":"legal","79":"mobile-app","80":"onboarding","81":"planner","82":"pricing","84":"settings","85":"tool-calories","86":"tool-critical-power","87":"tool-ftp","88":"tool-good-ftp","89":"tool-hr-zones","90":"tool-intensity-factor","91":"tool-lactate-threshold","92":"tool-power-to-weight","93":"tool-power-zones","94":"tool-race-time","95":"tool-running-pace","96":"tool-tss","97":"tool-variability-index","98":"tool-vo2-max","99":"tool-zone-2","100":"tools","101":"tooltip-modal","102":"training-plans","103":"unsubscribe","104":"upgrade","105":"vendors~highcharts","106":"vendors~mapbox","107":"workout-builder","108":"zwift-importer"}[chunkId]||chunkId) + "-" + {"0":"709cf0dc4a4e0f437611","1":"99692501789a998d12fa","2":"0a64d213b3a55208a0c4","3":"450c370599e3720a0182","4":"00931aaf150a66e73b67","5":"c0f797f78873e5ea1608","6":"4f678ff4dc69f8b9d823","7":"c36b7dfb2d12ce3805b7","8":"28616157b3ff87cd004b","9":"264c5978986d50986ed8","10":"a071abeb7e503ecbc29b","11":"6c2f22c047d6dd379a01","12":"536e18efe4506afce898","13":"264bf2a8d5b112d25015","14":"f1a0944e4222161063a0","15":"527e9b39e6deb4e773dc","16":"b3d038ed069e08980ab7","17":"e51a8dfcabf58cd5b017","18":"2c224176bb599c231aae","19":"d0733592621bcf357675","20":"9184470a45f259d68296","21":"1d945e644fcae9e7fbda","22":"b070cde9733412a1dbd5","23":"8aa48665038051bf4909","24":"bcc3b0b95a3abde6580f","25":"b1361169f52f5a118e0f","26":"087a02dbaf89f91caabd","27":"038998f296bb1d00b5a5","28":"033b5884bd0eeb2b2afa","29":"d0f3331fae32d29289f9","30":"eb29e10ea3343bb9c903","31":"d94b743c7ce1686b47f6","32":"90a44bc50b9b6c63c57b","33":"f7adb4f1055e2a1ef1e4","34":"646138b182e9c406e12a","35":"666955434d0c7345aef9","36":"d41bcaa5c8c89bd9e5ca","37":"0925997e96face0c371e","38":"a7e9e7e650ea600f0e56","39":"4e74880530aa1c0025c3","40":"9b46db423d902459882e","41":"762b694fc80543b7d578","42":"567cee8b449f606c4af2","43":"cac89fd0c964160f5347","44":"29130a04059dacc6fbd8","45":"9e1dc7aafe031e0c1bec","46":"9648c26d7461f27b6c24","47":"40642fe23cc69897caf1","48":"e257cd38dae552dd0eb9","49":"a9ebc4902e0860bd94d1","50":"97f859b04f20105f167d","51":"0d436c9c6b8463f83029","52":"8a78b016362cbb4fbeb1","53":"302896371356287fec81","54":"286d64fb9a3d65489baa","55":"63c526c11210d24aeef3","56":"f653314e866d19b0d1d0","57":"46c3dcf417c76a6cc586","58":"28dc9d3056300189cee9","59":"11619c39069180802a20","60":"e1871e8206ef91c20d92","61":"38ed0b0d0727f8e6179f","62":"b5d2d9afea9e4ba7da91","63":"22d40a71ba7b3b222d99","64":"8daa77bce53bbb8c4685","65":"b9ea8a13193136fab7d5","66":"b34609a6f61fa6900323","67":"45c62762ed1bfa895dfc","68":"e4776e0f592b01d79289","69":"ad9b79e5669f7b6e932f","70":"6f45fbe5aeac861526e9","72":"b33f54e71e9cce97bb83","73":"860b4e9b4a579b479761","74":"15cc5f871d3d027bfc6b","75":"04d710f9236fb6fa3421","76":"ef59a20a132098b779a6","77":"7a2b3a771e233c8a6861","78":"deab27ee51c0b1d1c0a9","79":"c261e0ea045b14cdb839","80":"16dd5cb4f03a2fb979da","81":"828da9995f01d4bb6351","82":"91c44675687e1c835919","84":"44865757aaa861aa6724","85":"ea7a1b822a2b5820bc12","86":"c28d9956422c55ac4e9a","87":"557f3579ba24ab5eaf68","88":"9d204d363e3191a6f182","89":"73fe619da7ada39afc49","90":"ce6365b1f0e2092a3676","91":"9ebd50bd1a2c7753526d","92":"e8dfec78b5b2085a54bd","93":"a6f991873d8bfc9ad7cc","94":"1a1f1cac671aedc11add","95":"255110ea2903dc143cc3","96":"fb6e420c3a875df6f296","97":"f7caa6ad6ba6d1da041d","98":"a5dbf6dac30047e98014","99":"33d704ed41d3b036f8cf","100":"1add80861ff446da001d","101":"0c93bd9698e10c4f88bb","102":"d41ee97862b8212efcd7","103":"07628b37137965cfdc12","104":"c2aa32e2d56abb2bd5c3","105":"c7a4525022b294e44853","106":"a24d394e64caa401e039","107":"1def6b41e7f971529515","108":"ef5aa2c332651e4b28d9","109":"178de3ce03aabf17a078"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1,"5":1,"8":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"66":1,"67":1,"68":1,"72":1,"73":1,"74":1,"76":1,"80":1,"81":1,"84":1,"85":1,"86":1,"87":1,"98":1,"102":1,"107":1,"108":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"2":"cycling-workouts~dashboard~planner~workout-builder~zwift-importer","3":"cycling-workouts~planner~workout-builder~zwift-importer","4":"vendors~activity~cycling-workouts~workout-builder~zwift-importer","5":"cycling-workouts~workout-builder~zwift-importer","6":"vendors~dashboard~planner~settings","7":"vendors~glossary~settings~tooltip-modal","10":"glossary~tooltip-modal","66":"activity","67":"admin","68":"ai-cycling-coach","69":"alternatives","70":"ambassadors","72":"changelog","73":"cycling-workouts","74":"dashboard","75":"glossary","76":"help","77":"highcharts","78":"legal","79":"mobile-app","80":"onboarding","81":"planner","82":"pricing","84":"settings","85":"tool-calories","86":"tool-critical-power","87":"tool-ftp","88":"tool-good-ftp","89":"tool-hr-zones","90":"tool-intensity-factor","91":"tool-lactate-threshold","92":"tool-power-to-weight","93":"tool-power-zones","94":"tool-race-time","95":"tool-running-pace","96":"tool-tss","97":"tool-variability-index","98":"tool-vo2-max","99":"tool-zone-2","100":"tools","101":"tooltip-modal","102":"training-plans","103":"unsubscribe","104":"upgrade","105":"vendors~highcharts","106":"vendors~mapbox","107":"workout-builder","108":"zwift-importer"}[chunkId]||chunkId) + "-" + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"d4aa2e17","4":"31d6cfe0","5":"1be60833","6":"31d6cfe0","7":"31d6cfe0","8":"a1a1ac68","9":"31d6cfe0","10":"31d6cfe0","11":"61c7e243","12":"61c7e243","13":"61c7e243","14":"61c7e243","15":"2f389482","16":"61c7e243","17":"61c7e243","18":"61c7e243","19":"a6b46e9d","20":"61c7e243","21":"61c7e243","22":"61c7e243","23":"5209a9a1","24":"71da6349","25":"f7381212","26":"124d1d99","27":"31d6cfe0","28":"31d6cfe0","29":"31d6cfe0","30":"31d6cfe0","31":"31d6cfe0","32":"31d6cfe0","33":"31d6cfe0","34":"31d6cfe0","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"31d6cfe0","39":"31d6cfe0","40":"31d6cfe0","41":"31d6cfe0","42":"31d6cfe0","43":"31d6cfe0","44":"31d6cfe0","45":"31d6cfe0","46":"31d6cfe0","47":"31d6cfe0","48":"31d6cfe0","49":"31d6cfe0","50":"31d6cfe0","51":"31d6cfe0","52":"31d6cfe0","53":"31d6cfe0","54":"31d6cfe0","55":"31d6cfe0","56":"31d6cfe0","57":"31d6cfe0","58":"31d6cfe0","59":"31d6cfe0","60":"31d6cfe0","61":"31d6cfe0","62":"31d6cfe0","63":"31d6cfe0","64":"31d6cfe0","65":"31d6cfe0","66":"e91d28c4","67":"68cd1f3e","68":"475867f1","69":"31d6cfe0","70":"31d6cfe0","72":"8ef9be1f","73":"12262c52","74":"4bd2bb02","75":"31d6cfe0","76":"1c58ab9a","77":"31d6cfe0","78":"31d6cfe0","79":"31d6cfe0","80":"9bd38e58","81":"e2b4df8b","82":"31d6cfe0","84":"017bca30","85":"40dbcddf","86":"7a930ee0","87":"467fc90f","88":"31d6cfe0","89":"31d6cfe0","90":"31d6cfe0","91":"31d6cfe0","92":"31d6cfe0","93":"31d6cfe0","94":"31d6cfe0","95":"31d6cfe0","96":"31d6cfe0","97":"31d6cfe0","98":"9a83ae2b","99":"31d6cfe0","100":"31d6cfe0","101":"31d6cfe0","102":"afe04cc0","103":"31d6cfe0","104":"31d6cfe0","105":"31d6cfe0","106":"31d6cfe0","107":"ac42cb4f","108":"fa328bb7","109":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d3s6jo6q0vpov5.cloudfront.net/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 264);
